export const rulesMixin = {
  data() {
    return {
      notNull: v => v !== null || "Ne doit pas être nulle",
      aboveZero: v => v >= 0 || "Doit être supérieur à 0"
    };
  }
};
